import { formatTimeStr, timeFormat } from '@/utils/other';
import BaseListClass from './BaseListClass';
import ListClass from './ListClass';
import RequestApi from './RequestApiClass';


type ISearchRequirement = IRequirement.IRequest.IGetRequirement;
type IRequirementInfo = IRequirement.IResponse.IRequirementInfo;

interface IGetRequirementParams {
  pageindex: number;
  pagesize: number;
}

const defaultParams: IGetRequirementParams = {
  pageindex: 1,
  pagesize: 100,
};
export default class RequirementListClass extends BaseListClass<IRequirementInfo> {
  public $requestParams: ISearchRequirement = { ...defaultParams };
  public detailParams = {
    returnComment: true,
    returnModule: true,
    returnQuotation: true,
  };
  constructor() {
    super({
      list: new ListClass<IRequirementInfo>(),
      requestApi: new RequestApi('Requirement'),
    });
  }
  public $initRequestParams() {
    this.$requestParams = { ...defaultParams };
  }
  public convertData(requirements: IRequirementInfo[]): IRequirementInfo[] {
    return requirements.map((requirement) => ({
      ...requirement,
      due: formatTimeStr(requirement.due),
      createdOn: timeFormat(requirement.createdOn),
    }));
  }
  public checkItem(requirement: IRequirementInfo) {
    const result: boolean[] = [];
    ['id', 'issueId', 'projectId', 'status'].forEach((key) => {
      if (this.$requestParams[key as keyof ISearchRequirement]) {
        result.push(
          requirement[key as keyof IRequirementInfo] ===
            this.$requestParams[key as keyof ISearchRequirement],
        );
      }
    });
    if (this.$requestParams.title) {
      result.push(requirement.title.includes(this.$requestParams.title));
    }
    return result.every((value) => value);
  }
}

export const requirementListInstance = new RequirementListClass();
